<template>
    <div class="mb-3">

        <div class="my-1">
            <label class="col-sm-3 col-form-label">Field</label>
            <select id="operand1Options" class="form-control small-form-control"
                    v-model="dynamicFieldData.operand1Id">
                <option v-for="field in availableOperands" :value="field.index">{{field.name}}</option>
            </select>
        </div>

        <div class="my-1">
            <label class="col-sm-3 col-form-label">Operator</label>
            <select class="form-control small-form-control"
                    v-model="dynamicFieldData.operator">
                <option value="add">add</option>
                <option value="subtract">subtract</option>
                <option value="multiply">multiply</option>
                <option value="divide">divide</option>
            </select>
        </div>

        <div class="my-1">
            <label class="col-sm-3 col-form-label">Field</label>
            <select id="operand2Options" class="form-control small-form-control"
                    v-model="dynamicFieldData.operand2Id">
                <option v-for="field in availableOperands" :value="field.index">{{field.name}}</option>
            </select>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'DynamicFieldOptions',
        props: ['field', 'table', 'dynamicFieldData'],
        computed: {
            availableOperands() {
                return webase.utils.table.getAvailableOperands(this.table)
            }
        },
        data () {
            return {
                model: webase.model
            }
        }
    }
</script>

<style>

</style>
